import React, { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInactivityTimeout } from '../../hooks/useInactivityTimeout';
import { logout, refreshAccessToken } from '../../services/auth';
import InactivityModal from './InactivityModal';

/**
 * Cierra la sesión por inactividad (control de seguridad para máquinas
 * compartidas). Se monta dentro del shell autenticado, así solo corre para
 * usuarios logueados. Es ortogonal al auto-refresh del access token.
 */
const InactivityGuard: React.FC = () => {
  const navigate = useNavigate();
  const expiringRef = useRef(false);

  const handleExpire = useCallback(async () => {
    if (expiringRef.current) return;
    expiringRef.current = true;
    await logout();
    navigate('/login', { replace: true });
  }, [navigate]);

  const { phase, secondsLeft, stayActive } = useInactivityTimeout(handleExpire);

  const handleStay = useCallback(() => {
    stayActive();
    // Confirma con el servidor que la sesión sigue viva (no bloquea la UX).
    void refreshAccessToken().catch(() => {
      /* si el refresh falla, el interceptor/bootstrap ya manejará el redirect */
    });
  }, [stayActive]);

  return (
    <InactivityModal
      isOpen={phase === 'warning'}
      secondsLeft={secondsLeft}
      onStay={handleStay}
      onLogout={handleExpire}
    />
  );
};

export default InactivityGuard;
